class VideoModal extends HTMLElement {
    constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.modalVideo = this.querySelector('[modal-video]');
        this.opener = this.querySelector('[data-opener]');
        this.closure = this.querySelector('[data-closure]');
    }

    onModalClose() {
        this.dialog.close();
        this.modalVideo.pause();
    }

    onModalOpen() {
        this.dialog.showModal();
        this.modalVideo.currentTime = 0;
        this.modalVideo.play();
    }

    bindListeners() {
        this.opener.addEventListener('click', this.onModalOpen.bind(this));
        this.closure.addEventListener('click', this.onModalClose.bind(this));
    }

    connectedCallback() {
        this.bindListeners();
    }
}

if (!customElements.get('video-modal')) {
    customElements.define('video-modal', VideoModal);
}